Vue.component('category-filter-checkbox', {
    props: {
        category: {
            required: true,
        },
        selectAll: {
            default: false,
        },
    },
    //language=HTML
    template: `
      <li class="nav-item">
          <template v-if="category.children && category.children.length">
              <label>
                  <input ref="checkbox" type="checkbox" :name="'category-' + category.id" v-model="checked" @change="selectCategory"/>
                  {{ category.name }}
                  <template v-if="category.posted_count">
                      ({{ category.posted_count }})
                  </template>
              </label>
              <button class="btn btn-sm btn-plain toggle-btn fal fa-chevron-down ml-auto" :class="{'is-open': isOpen}" @click.prevent="toggleMenu"></button>
              <div class="collapse" :id="'collapseMenu' + category.id">
                  <category-filter :categories="category.children" :sub-menu="true"></category-filter>
              </div>
          </template>
          <template v-else>
              <label>
                  <input ref="checkbox" type="checkbox" :name="'category-' + category.id" v-model="checked" @change="selectCategory"/>
                  {{ category.name }}
                  <template v-if="category.posted_count">
                      ({{ category.posted_count }})
                  </template>
              </label>
          </template>
      </li>
  `,
    data() {
        return {
            isOpen: false,
            checked: true,
        };
    },
    created() {
        Bus.$on('categoryFilterSelectAll', this.check);
        Bus.$on('categoryFilterUnselectAll', this.uncheck);
    },
    beforeDestroy() {
        Bus.$off('categoryFilterSelectAll', this.check);
        Bus.$off('categoryFilterUnselectAll', this.uncheck);
    },
    methods: {
        check() {
            this.checked = true;
        },
        uncheck() {
            this.checked = false;
        },
        toggleMenu() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                $('#collapseMenu' + this.category.id).collapse('show');
            } else {
                $('#collapseMenu' + this.category.id).collapse('hide');
            }
        },
        selectCategory(e) {
            if (this.category.parent_id == null) {
                if (e.target.checked) {
                    Bus.$emit('categoryFilterSelectAll');
                } else {
                    Bus.$emit('categoryFilterUnselectAll');
                }
            } else {
                if (e.target.checked) {
                    Bus.$emit('categoryFilterChecked', this.category);
                } else {
                    Bus.$emit('categoryFilterUnchecked', this.category);
                }
            }
        },
    },
});
